export default {
  please_pay_attention: 'Please pay attention!',
  new_deposit_instructions: 'New instruction how to deposit!',
  invoice_flow__selcom_ussd_push_message: 'Please complete the payment in your phone!',
  invoice_flow__step: 'STEP {index}: ',

  invoice_flow__vodacom: 'Vodacom',
  invoice_flow__airtel: 'Airtel',
  invoice_flow__tigo: 'Tigo',
  invoice_flow__halopesa: 'Halopesa',
  invoice_flow__zantel_ezypesa: 'Zantel ezypesa',

  //Vodacom
  invoice_flow__vodacom_steps_step_1: 'Dial *150*00#',
  invoice_flow__vodacom_steps_step_2: 'Choose 4 (Pay by mpesa)',
  invoice_flow__vodacom_steps_step_3: 'Choose 4 (Enter business number)',
  invoice_flow__vodacom_steps_step_4: 'Enter business number: {business_number}',
  invoice_flow__vodacom_steps_step_5: 'Enter reference number: {reference_number}',
  invoice_flow__vodacom_steps_step_6: 'Enter amount: {amount}',
  invoice_flow__vodacom_steps_step_7: 'Enter PIN (password)',
  invoice_flow__vodacom_steps_step_8: 'Press 1 to confirm payment',

  //Airtel
  invoice_flow__airtel_steps_step_1: 'Dial *150*60#',
  invoice_flow__airtel_steps_step_2: 'Choose 5 (Make payments)',
  invoice_flow__airtel_steps_step_3: 'Choose 4 (Enter business number)',
  invoice_flow__airtel_steps_step_4: 'Enter business number: {business_number}',
  invoice_flow__airtel_steps_step_5: 'Enter amount: {amount}',
  invoice_flow__airtel_steps_step_6: 'Enter the reference number: {reference_number}',
  invoice_flow__airtel_steps_step_7: 'Enter PIN (password)',

  //Tigo
  invoice_flow__tigo_steps_step_1: 'Dial *150*01#',
  invoice_flow__tigo_steps_step_2: 'Choose 4 (Pay bills)',
  invoice_flow__tigo_steps_step_3: 'Choose 3 (Enter business number)',
  invoice_flow__tigo_steps_step_4: 'Enter business number: {business_number}',
  invoice_flow__tigo_steps_step_5: 'Enter reference number: {reference_number}',
  invoice_flow__tigo_steps_step_6: 'Enter amount: {amount}',
  invoice_flow__tigo_steps_step_7: 'Enter PIN (password)',

  //Halopesa
  invoice_flow__halopesa_steps_step_1: 'Dial *150*88#',
  invoice_flow__halopesa_steps_step_2: 'Choose 4 (Pay Bills)',
  invoice_flow__halopesa_steps_step_3: 'Choose 3 (Business number)',
  invoice_flow__halopesa_steps_step_4: 'Enter business number: {business_number}',
  invoice_flow__halopesa_steps_step_5: 'Enter the reference number: {reference_number}',
  invoice_flow__halopesa_steps_step_6: 'Enter amount: {amount}',
  invoice_flow__halopesa_steps_step_7: 'Enter PIN (password)',
  invoice_flow__halopesa_steps_step_8: 'Press 1 to confirm payment',

  //Zantel ezypesa
  invoice_flow__zantel_ezypesa_steps_step_1: 'Dial *150*02#',
  invoice_flow__zantel_ezypesa_steps_step_2: 'Choose 5 (Payments)',
  invoice_flow__zantel_ezypesa_steps_step_3: 'Choose 3 (Business number)',
  invoice_flow__zantel_ezypesa_steps_step_4: 'Enter business number: {business_number}',
  invoice_flow__zantel_ezypesa_steps_step_5: 'Enter the reference number: {reference_number}',
  invoice_flow__zantel_ezypesa_steps_step_6: 'Enter amount: {amount}',
  invoice_flow__zantel_ezypesa_steps_step_7: 'Enter password to confirm',
};
